import {Table} from "antd";
import React, {useEffect, useMemo, useState} from "react";
import {QueryString} from "../../utils/Querystring";
import DraggableTable from "./components/DraggableTable";

export default function TableUI({data, columns, className, onDragEndHandler, fetchingData, draggableKey, ...props}) {
    const [pagination, setPagination] = useState({
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total
    });
    const [loading, setLoading] = useState(false);

    const handleTableChange = async (pagination, filters, sorter) => {
        setLoading(true);

        await fetchingData({
            ...QueryString.parseQueryString(window.location.search),
            sort_column: sorter.field,
            sort_type: sorter.order === 'ascend' ? "asc" : "desc",
            page: pagination.current,
            per_page: pagination.pageSize,
            ...filters,
        });

        setLoading(false)
    };

    useEffect(() => {
        setPagination({
            current: data.current_page,
            pageSize: data.per_page,
            total: data.total
        })
    }, [data]);

    const tableData = useMemo(() => data.data || data, [data]);

    if (draggableKey) {
        return <DraggableTable columns={columns}
                               dataSource={tableData.map((data, index) => ({...data, _indexDnD: index + 1}))}
                               pagination={pagination}
                               loading={loading}
                               onChange={handleTableChange}
                               onDragEndHandler={onDragEndHandler}
                               draggableKey={draggableKey}
                               {...props}/>
    }

    return (
        <Table columns={columns}
               dataSource={tableData}
               pagination={pagination}
               loading={loading}
               className={className}
               onChange={handleTableChange}
               {...props}
        />
    )
}
